import type { FC } from "react";

import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { defaultMapperKey } from "../../../../core/mappers/mappers";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";
import { GenericSearchFormCriteria } from "../../../oldComponents/GenericSearchFormCriteria";
import type { PaymentMethod } from "../../../types/entities/paymentMethod";
import { PaymentMethodsTable } from "./PaymentMethodsTable";

export const PaymentMethodsPage: FC<NoneOwnProps> = () => {
    const table = <PaymentMethodsTable />;
    const searchForm = (
        // <SearchForm>
        <GenericSearchFormCriteria />
        // </SearchForm>
    );

    return (
        <PageLayout>
            <PageTitle translationKey="menu.methodsOfPayment" />
            <ResourceManager<PaymentMethod>
                useDataGroup
                dataMapperKey={defaultMapperKey}
                resource={ResourceName.PAYMENT_METHODS}
                table={table}
                searchForm={searchForm}
                actions={[Actions.ADD, Actions.DELETE, Actions.COPY, Actions.EXPORT, Actions.BATCH_UPDATE]}
            />
        </PageLayout>
    );
};
